// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RI5p","top":"styles_top__1jY12","left":"styles_left__1NqMa","description":"styles_description__yzkuu"};